export interface GossipItem {
  id: number;
  tag: string;
  time: string;
  title: string;
  summary: string;
  heat: number;
  tagColor: string;
}

export const hotTopics: GossipItem[] = [
  { id: 1, tag: "争议后续", time: "21:40", title: "顶流综艺嘉宾深夜发文，回应'划水'争议完整版来了", summary: "澄清时间线与节目组声明同时放出，粉丝与路人各执一词，热度持续走高。", heat: 986, tagColor: "primary" },
  { id: 2, tag: "红毯名场面", time: "20:15", title: "某颁奖礼后台同框名场面被挖出，网友直呼'梦幻联动'", summary: "多年前的彩排花絮重新翻红，两位主演先后隔空回应，评论区笑到打鸣。", heat: 921, tagColor: "accent" },
  { id: 3, tag: "综艺爆梗", time: "19:30", title: "新综艺首播即出圈，'打工人剧本'让观众共情到热搜", summary: "环节设计真实接地气，MC 临场反应圈粉，单条切片播放量破千万。", heat: 864, tagColor: "secondary" },
  { id: 4, tag: "音乐现场", time: "18:50", title: "演唱会安可环节突发事件，歌手现场即兴救场获好评", summary: "设备小故障意外成就神级现场，相关词条当晚冲上平台热榜前三。", heat: 732, tagColor: "accent" },
  { id: 5, tag: "影视路透", time: "17:20", title: "古装剧杀青路透流出，服化道质感引原著粉期待", summary: "片场氛围融洽，主创齐发声感谢剧组，播放平台预约数一夜暴涨。", heat: 658, tagColor: "secondary" },
  { id: 6, tag: "时尚话题", time: "16:05", title: "品牌代言官宣海报引热议，粉丝镜头技术再被夸奖", summary: "一镜到底的拍摄概念新奇，品牌方乘势放出拍摄花絮加码热度。", heat: 604, tagColor: "primary" },
];

export interface Channel {
  name: string;
  icon: string;
  image: string;
  items: { title: string; desc: string }[];
}

export const channels: Channel[] = [
  {
    name: "综艺名场面",
    icon: "ri-tv-2-line",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20stage%20spotlight%20with%20microphone%20and%20confetti%20on%20cream%20background%2C%20coral%20red%20and%20amber%20color%20palette%2C%20modern%20magazine%20style&width=600&height=400&seq=gossip-chan-show-01&orientation=landscape",
    items: [
      { title: "嘉宾怼导演名场面，这段没剧本是真没忍住", desc: "临场发挥的急智回答被做成表情包，节目组随后放出花絮力证无台本。" },
      { title: "'反内卷'环节爆冷逆袭，冠军人选跌破眼镜", desc: "赛制临时改版引发讨论，观众投票数刷新该节目历史纪录。" },
    ],
  },
  {
    name: "影视路透局",
    icon: "ri-movie-2-line",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20film%20camera%20and%20clapperboard%20on%20cream%20background%2C%20coral%20red%20and%20amber%20palette%2C%20modern%20magazine%20style&width=600&height=400&seq=gossip-chan-movie-01&orientation=landscape",
    items: [
      { title: "新剧开机仪式排面十足，班底阵容被评'稳了'", desc: "导演编剧首次同框，原著作者也到场站台，期待值直接拉满。" },
      { title: "杀青路透里的这场雨戏，路人都说氛围感天花板", desc: "雨中相望的镜头花絮被提前流出，正片还未上就已经预定热搜。" },
    ],
  },
  {
    name: "音乐现场",
    icon: "ri-mic-line",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20vinyl%20record%20and%20neon%20stage%20notes%20on%20cream%20background%2C%20coral%20red%20and%20amber%20palette%2C%20modern%20magazine%20style&width=600&height=400&seq=gossip-chan-music-01&orientation=landscape",
    items: [
      { title: "年度舞台大赏，多首金曲完成经典现场", desc: "久未同台的搭档再度合体，观众直呼'青春回来了'。" },
      { title: "新专辑先行曲空降榜单，收听量一小时破纪录", desc: "歌迷自发二创翻唱，相关话题覆盖多个内容平台。" },
    ],
  },
  {
    name: "时尚红毯",
    icon: "ri-handbag-line",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20red%20carpet%20and%20high%20heels%20spotlight%20on%20cream%20background%2C%20coral%20red%20and%20amber%20palette%2C%20modern%20magazine%20style&width=600&height=400&seq=gossip-chan-fashion-01&orientation=landscape",
    items: [
      { title: "红毯造型盘点出炉，这几位把高级感拿捏住了", desc: "造型师公开灵感来源，同色系穿搭教程光速刷屏变美圈。" },
      { title: "意外走光的瞬间被救场，情商反应获全场掌声", desc: "突发状况下的应变被网友夸上热搜，成为当日最佳名场面。" },
    ],
  },
  {
    name: "电竞热话",
    icon: "ri-gamepad-line",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20game%20controller%20and%20trophy%20on%20cream%20background%2C%20coral%20red%20and%20amber%20palette%2C%20modern%20magazine%20style&width=600&height=400&seq=gossip-chan-esport-01&orientation=landscape",
    items: [
      { title: "世界赛抽签结果出炉，'死亡小组'悬念拉满", desc: "赛区对战表公布，几家欢喜几家愁，解说员直呼刺激。" },
      { title: "老将复出首秀即封神，粉丝连夜庆祝", desc: "时隔两年回归，状态依旧在线，赛后采访金句频出。" },
    ],
  },
  {
    name: "圈内花边",
    icon: "ri-chat-heart-line",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20speech%20bubbles%20and%20popcorn%20on%20cream%20background%2C%20coral%20red%20and%20amber%20palette%2C%20modern%20magazine%20style&width=600&height=400&seq=gossip-chan-talk-01&orientation=landscape",
    items: [
      { title: "被偶遇同框旅游，双方经纪团队'不回应'再添联想", desc: "网友从细节扒出更多证据，当事人保持沉默引发持续讨论。" },
      { title: "老友节目重聚泪目现场，多年恩怨疑似和解", desc: "一句'都过去了'让弹幕刷屏，两人还约好下次再聚。" },
    ],
  },
];

export interface RecapNode {
  time: string;
  stage: string;
  title: string;
  points: string[];
  note: string;
}

export const recapTimeline: RecapNode[] = [
  {
    time: "10:00",
    stage: "开盘",
    title: "早间第一瓜：片场剧透引发原著党分歧",
    points: ["上午流传一组路透生图，细节争议冲上早间热榜", "剧方中午回应称'以官方物料为准'", "相关讨论持续到午间才逐渐降温"],
    note: "属于'雷声大、雨点小'，静候后续物料即可。",
  },
  {
    time: "13:30",
    stage: "发酵",
    title: "午间：综艺赛果争议进入白热化",
    points: ["排名公布后部分观众质疑票数公平性", "平台晒出公证说明，仍难平部分争议", "MC 深夜直播回应，情绪稳定获点赞"],
    note: "本日最胶着的瓜，双方都在等一个'实锤'。",
  },
  {
    time: "17:20",
    stage: "中场",
    title: "傍晚：古装剧杀青路透成最大惊喜",
    points: ["杀青合影流出，主创造型全员在线", "服化道细节被逐一放大细品", "播放平台顺势开启预约，数据大涨"],
    note: "难得一见的'正向瓜'，评论区一片期待之声。",
  },
  {
    time: "21:40",
    stage: "收尾",
    title: "晚间：'划水'争议当事人完整回应",
    points: ["当事人发文晒出时间线与排练记录", "节目组同步发布官方声明站台", "热度峰值登顶，事件基本收束"],
    note: "回应与证据链相对完整，吃瓜可暂时收摊。",
  },
];

export interface Review {
  quote: string;
  author: string;
  role: string;
}

export const userReviews: Review[] = [
  { quote: "晚上睡前刷一下瓜田晚报，今天错过的热搜一篇就补完了，真的很省心。", author: "咖啡不加糖", role: "吃瓜五年的老粉" },
  { quote: "争议后续整理得很清楚，时间线一目了然，比我自己一个个翻靠谱多了。", author: "今天也要开心呀", role: "综艺爱好者" },
  { quote: "更新很准时，每晚十点准时收摊，评论区氛围也很好，理性吃瓜不吵架。", author: "摸鱼小能手", role: "晚睡党" },
  { quote: "热点分得很细，综艺、影视、音乐、电竞都有，想找哪块翻哪块。", author: "一颗小梅子", role: "影视剧路人粉" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  { q: "吃瓜今日多久更新一次？", a: "每晚 22:00 准时发布当日瓜田晚报，覆盖全天热点与收尾盘点；临时的大瓜会在盘中即时补充，避免大家错过关键进展。" },
  { q: "今天错过的直播/热搜还能补吗？", a: "可以。瓜田晚报会按时间线整理今日全部瓜，包含开场、发酵、中场到收尾的完整经过，并标注争议后续，一篇即可补完。" },
  { q: "吃瓜信息从哪里来？", a: "内容主要汇总公开的节目路透、平台热搜与官方声明，并在文内尽量标注来源。我们坚持'来源优先、事实先行'，提醒大家理性吃瓜、不传谣。" },
  { q: "看到疑似不实的信息怎么办？", a: "可通过页脚邮箱联系编辑部核实。我们收到反馈后会复查相关信源，确认存在偏差时会及时更正或下架相关内容。" },
  { q: "吃瓜要钱吗？要不要登录？", a: "完全免费、无需登录注册。所有晚间汇总与复盘内容都公开可读，打开页面即可查看。" },
];

export const quickTags: string[] = [
  "综艺名场面",
  "影视路透",
  "音乐现场",
  "时尚红毯",
  "电竞热话",
  "圈内花边",
  "争议后续",
  "瓜田收尾",
];